module.exports = __webpack_public_path__ + "static/medograf-hero@2x-min-f9d1f655eb5410fbd5f681e6eb7cf5a4.png";